/**
 * Locale codes and US indexability for build-time consumers. next.config.js can import only
 * .mjs modules, so this list mirrors `locales` in src/config/locale.ts; the drift is guarded by
 * src/next-us-noindex-headers.test.ts.
 */

/** @type {readonly string[]} */
export const LOCALE_CODES = Object.freeze([
	"en",
	"de",
	"it",
	"es",
	"es-mx",
	"fr",
	"nl",
	"pt",
	"pt-br",
	"pl",
	"sv",
	"da",
	"el",
	"cs",
	"fi",
	"ro",
	"hu",
	"sk",
	"tr",
	"nb",
	"bg",
	"hr",
	"sl",
	"sr",
	"bs",
	"mk",
	"lt",
	"lv",
	"et",
]);

/** @type {readonly ("en" | "es" | "es-mx")[]} */
export const US_INDEXABLE_LOCALES = Object.freeze(["en", "es", "es-mx"]);

export function usNoindexLocales() {
	return LOCALE_CODES.filter((locale) => !US_INDEXABLE_LOCALES.includes(locale));
}

/**
 * next.config.js headers() entry: an HTTP-level noindex for locale/US combinations that are
 * never indexed. Lives in config headers, not in middleware (middleware headers end up in the
 * route cache, incident 19.09.2026) and not in nginx.
 */
export function usNoindexHeaderRule() {
	return {
		source: `/:locale(${usNoindexLocales().join("|")})/us/:path*`,
		headers: [{ key: "X-Robots-Tag", value: "noindex, follow" }],
	};
}
